import AddCircleIcon from '@mui/icons-material/AddCircle';
import {Autocomplete, Stack, TextField} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {useTheme} from '@mui/material/styles';
import type * as React from 'react';
import type {CapacityLabel} from '@/types/CapacityLabel';

export type AutocompleteOption = {
    label : string;
    id : string;
};

type Props = {
    value : AutocompleteOption | undefined;
    setValue : (value : AutocompleteOption | undefined) => void;
    setTextValue : (value : string) => void;
    selectedCallback ?: () => void;
    capacityLabels : CapacityLabel[];
};

const CapacityDefaultAutoComplete : React.FC<Props> = (
    {
        value,
        setValue,
        setTextValue,
        selectedCallback,
        capacityLabels,
    } : Props
) => {
    const theme = useTheme();

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const handleAutocompleteChange = (_event : React.SyntheticEvent, value : unknown) => {
        const selectedOption = value as AutocompleteOption;
        setValue(selectedOption);
    };

    const options = capacityLabels.map(label => {
        return {
            label: label.name,
            id: label.timeLabelID,
        };
    });

    return <Stack sx={{flexDirection: 'row'}}>
        <Autocomplete
            value={value ?? ''}
            id="capacityDefault"
            options={options}
            renderInput={params => <TextField
                value={value}
                sx={{
                    zIndex: 2,
                }}
                {...params}
                label={'Add time category'}
            />}
            onChange={(event : React.SyntheticEvent, value : unknown) => {
                handleAutocompleteChange(event, value);
            }}
            // eslint-disable-next-line @typescript-eslint/naming-convention
            onInputChange={(_event : React.SyntheticEvent, value : string) => {
                setTextValue(value);
            }}
            renderOption={(props, option : unknown) => {
                const currentOption = option as AutocompleteOption;

                return (
                    <li {...props} key={currentOption.id}>
                        {currentOption.label}
                    </li>
                );
            }}
            freeSolo={true}
            blurOnSelect
            sx={{
                my: 1,
                width: '100%',
                '& .MuiInputLabel-root': {
                    borderRadius: '8px',
                    color: theme.palette.primary.main,
                },
            }}
        />
        {selectedCallback && <IconButton
            aria-label="delete"
            onClick={() => {
                selectedCallback();
            }}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                color: 'black',
            }}
        >
            <AddCircleIcon/>
        </IconButton>}
    </Stack>;
};

export default CapacityDefaultAutoComplete;
